import { ApiEndpointBuilder } from "@/services/api/types";
import { Nullable } from "react-advanced-cropper";
export enum TenantMembership {
  MEMBER,
  OWNER,
}

export enum PlanType {
  BASIC = 1,
  CRM_VAULT = 2,
  ICRM = 5,
  BUSINESS = 10,
  ENTERPRISE = 15,
}
export const PlanName = [
  { id: 1, name: "BASIC" },
  { id: 2, name: "CRM_VAULT" },
  { id: 5, name: "ICRM" },
  { id: 10, name: "BUSINESS" },
  { id: 15, name: "ENTERPRISE" },
];

export enum TenantTypeEnum {
  Personal = 0,
  Commercial = 5,
}

export interface TenantType {
  countryCode: string;
  id: string;
  name: string;
  isActive: boolean;
  isDefault: boolean;
  membership: TenantMembership;
  tenantType: TenantTypeEnum;
  isInvitationAccepted: boolean;
  isCrmVaultXMember?: boolean;
  licenses: PlanType[];
}

export interface CheckoutUrlRequestType {
  items: { priceId: string; quantity: number }[];
  localAccountId: string;
  referralCode: string | null;
  tenantId: string;
  tenantType: TenantTypeEnum;
  xTenantId?: string;
}

export interface TenantDetailedType
  extends Exclude<TenantType, "isDefault" | "membership" | "tenantType" | "licenses"> {
  adminEmail: string;
  adminFirstName: string;
  adminLastName: string;
  adminObjectId: string;
  validUpto: string;
  createdOn: string;
  issuer: string | null;
  licensesInfo: LicenseInfo[];
  type: TenantTypeEnum;
}

export interface LicenseInfo {
  quantity: number;
  usedQuantity: number;
  license: PlanType;
}
export const getTenantsList = (builder: ApiEndpointBuilder) => {
  return builder.query<TenantType[], void>({
    query: () => ({
      url: `/users/tenants`,
      method: "GET",
    }),
  });
};

export const getTenant = (builder: ApiEndpointBuilder) => {
  return builder.query<TenantDetailedType, string>({
    query: id => {
      const headers: Record<string, string> = {};
      if (id) {
        headers["x-tenant"] = id;
      }
      return { url: `/tenants/${id}`, method: "GET", headers };
    },
    providesTags: res =>
      res ? [{ type: "tenantDetails", id: res.id }] : [{ type: "tenantDetails", id: "LIST" }],
  });
};

export type UpdateSubscriptionRequest = {
  items: {
    id: Nullable<string>;
    priceId: string;
    quantity: number;
  }[];
  prorationDate: string;
};
// stripe portal

export const getStripePortalUrl = (builder: ApiEndpointBuilder) => {
  return builder.query<string, void>({
    query: () => ({
      url: `/checkout/portal`,
      method: "GET",
    }),
  });
};

const getCheckoutUrl = (builder: ApiEndpointBuilder) => {
  return builder.query<{ url: string | undefined }, CheckoutUrlRequestType>({
    query: ({ items, localAccountId, referralCode, xTenantId, tenantId, tenantType }) => ({
      url: `/checkout`,
      method: "POST",
      headers: xTenantId
        ? {
            "X-Tenant": xTenantId,
          }
        : undefined,
      body: {
        checkoutItems: items,
        customerAzureObjectId: localAccountId,
        referralCode: referralCode,
        isWebsite: false,
        tenantId,
        tenantType,
      },
    }),
  });
};
export default getCheckoutUrl;
